export var NKSelectS = [
    // 0-16
    { NKSelectS: { '0': 165.62, '600': 160.19, '1200': 115.62, '3000': 77.11 } },
    // 17-20
    { NKSelectS: { '0': 200.04, '600': 166.41, '1200': 150.04, '3000': 111.11 } },
    // 21
    { NKSelectS: { '0': 278.55, '600': 220.15, '1200': 173.32, '3000': 119.71 } },
    // 22
    { NKSelectS: { '0': 284.32, '600': 227.15, '1200': 179.38, '3000': 124.65 } },
    // 23
    { NKSelectS: { '0': 290.17, '600': 234.24, '1200': 185.54, '3000': 129.65 } },
    // 24
    { NKSelectS: { '0': 296.08, '600': 241.39, '1200': 191.74, '3000': 134.69 } },
    // 25
    { NKSelectS: { '0': 301.97, '600': 248.41, '1200': 197.89, '3000': 139.7 } },
    // 26
    { NKSelectS: { '0': 307.88, '600': 255.37, '1200': 204, '3000': 144.72 } },
    // 27
    { NKSelectS: { '0': 313.81, '600': 262.28, '1200': 210.1, '3000': 149.76 } },
    // 28
    { NKSelectS: { '0': 319.76, '600': 269.15, '1200': 216.18, '3000': 154.82 } },
    // 29
    { NKSelectS: { '0': 325.72, '600': 275.99, '1200': 222.25, '3000': 159.89 } },
    // 30
    { NKSelectS: { '0': 331.62, '600': 282.76, '1200': 228.23, '3000': 164.94 } },
    // 31
    { NKSelectS: { '0': 337.35, '600': 289.31, '1200': 234.03, '3000': 169.88 } },
    // 32
    { NKSelectS: { '0': 343.05, '600': 295.82, '1200': 239.78, '3000': 174.82 } },
    // 33
    { NKSelectS: { '0': 348.82, '600': 302.38, '1200': 245.57, '3000': 179.84 } },
    // 34
    { NKSelectS: { '0': 354.66, '600': 309.03, '1200': 251.44, '3000': 184.96 } },
    // 35
    { NKSelectS: { '0': 360.72, '600': 315.89, '1200': 257.51, '3000': 190.28 } },
    // 36
    { NKSelectS: { '0': 367.02, '600': 323, '1200': 263.82, '3000': 195.82 } },
    // 37
    { NKSelectS: { '0': 373.6, '600': 330.38, '1200': 270.42, '3000': 201.62 } },
    // 38
    { NKSelectS: { '0': 380.62, '600': 338.23, '1200': 277.45, '3000': 207.79 } },
    // 39
    { NKSelectS: { '0': 388.12, '600': 346.58, '1200': 284.97, '3000': 214.37 } },
    // 40
    { NKSelectS: { '0': 395.94, '600': 355.23, '1200': 292.8, '3000': 221.25 } },
    // 41
    { NKSelectS: { '0': 404.07, '600': 364.21, '1200': 300.95, '3000': 228.44 } },
    // 42
    { NKSelectS: { '0': 412.51, '600': 373.5, '1200': 309.4, '3000': 235.91 } },
    // 43
    { NKSelectS: { '0': 421.26, '600': 383.12, '1200': 318.16, '3000': 243.65 } },
    // 44
    { NKSelectS: { '0': 430.3, '600': 393.05, '1200': 327.21, '3000': 251.66 } },
    // 45
    { NKSelectS: { '0': 439.63, '600': 403.22, '1200': 336.55, '3000': 259.92 } },
    // 46
    { NKSelectS: { '0': 449.23, '600': 413.65, '1200': 346.17, '3000': 268.43 } },
    // 47
    { NKSelectS: { '0': 459.11, '600': 424.34, '1200': 356.05, '3000': 277.2 } },
    // 48
    { NKSelectS: { '0': 469.24, '600': 435.26, '1200': 366.2, '3000': 286.21 } },
    // 49
    { NKSelectS: { '0': 479.64, '600': 446.43, '1200': 376.6, '3000': 295.51 } },
    // 50
    { NKSelectS: { '0': 490.26, '600': 457.83, '1200': 387.23, '3000': 305.03 } },
    // 51
    { NKSelectS: { '0': 501.17, '600': 469.5, '1200': 398.14, '3000': 314.85 } },
    // 52
    { NKSelectS: { '0': 512.26, '600': 481.34, '1200': 409.24, '3000': 324.9 } },
    // 53
    { NKSelectS: { '0': 523.62, '600': 493.43, '1200': 420.6, '3000': 335.26 } },
    // 54
    { NKSelectS: { '0': 535.17, '600': 505.7, '1200': 432.15, '3000': 345.91 } },
    // 55
    { NKSelectS: { '0': 546.87, '600': 518.11, '1200': 443.85, '3000': 356.82 } },
    // 56
    { NKSelectS: { '0': 558.88, '600': 530.82, '1200': 455.83, '3000': 368.11 } },
    // 57
    { NKSelectS: { '0': 571.16, '600': 543.79, '1200': 468.08, '3000': 379.78 } },
    // 58
    { NKSelectS: { '0': 583.76, '600': 557.06, '1200': 480.63, '3000': 391.89 } },
    // 59
    { NKSelectS: { '0': 596.71, '600': 570.7, '1200': 493.52, '3000': 404.49 } },
    // 60
    { NKSelectS: { '0': 610.01, '600': 584.67, '1200': 506.77, '3000': 417.62 } },
    // 61
    { NKSelectS: { '0': 623.74, '600': 599.04, '1200': 520.42, '3000': 431.34 } },
    // 62
    { NKSelectS: { '0': 637.89, '600': 613.81, '1200': 534.49, '3000': 445.7 } },
    // 63
    { NKSelectS: { '0': 652.32, '600': 628.86, '1200': 548.85, '3000': 460.62 } },
    // 64
    { NKSelectS: { '0': 667.25, '600': 644.4, '1200': 563.68, '3000': 476.31 } },
    // 65
    { NKSelectS: { '0': 681.32, '600': 659.11, '1200': 577.76, '3000': 491.38 } },
    // 66
    { NKSelectS: { '0': 695.71, '600': 674.15, '1200': 592.14, '3000': 506.59 } },
    // 67
    { NKSelectS: { '0': 710.1, '600': 689.17, '1200': 606.54, '3000': 521.79 } },
    // 68
    { NKSelectS: { '0': 724.51, '600': 704.14, '1200': 620.95, '3000': 536.97 } },
    // 69
    { NKSelectS: { '0': 738.84, '600': 718.99, '1200': 635.28, '3000': 552.13 } },
    // 70
    { NKSelectS: { '0': 753.02, '600': 733.63, '1200': 649.46, '3000': 567.17 } },
];
